<template>
  <div>
    <div class="row">
      <b>Eventos</b>
    </div>
    <br>
    <div class="row" v-for="comment in comments" v-bind:key="comment.objectId">
      <div class="col-xs-6 left">        
        <comment-icon class="icon" :event="comment.event"></comment-icon>
        <div class="user-comment"><comment-event :event="comment.event"/> ({{comment.owner.name}})</div>
      </div>
      <div class="col-xs-6 right"><b>{{format(comment.createdAt)}}</b></div>
    </div>
  </div>
</template>

<script>
import CommentIcon from './CommentIcon'
import CommentEvent from './CommentEvent'
import moment from 'moment-twitter'

export default {
  props: ['comments'],
  components: {
    CommentIcon,
    CommentEvent
  },
  methods: {
    format (date) {
      moment.locale('pt-br')
      return moment(date).twitterShort()
    }
  }
}
</script>

<style scoped>

.left {
  border-right: 1px solid lightgray;
  text-align: right;
  height: 50px;
}

.icon {
  float: right;
  margin-right: -28px;
  margin-top: 10px;
  z-index: 1;
  cursor: pointer;
}

.icon:hover ~ .user-comment{
  display: inline-block;
}

.right {
  margin-top: 16px;
  font-size: 10px;
  color: gray;
  text-align: left;
}


.user-comment {
  display: none;
  text-align: right;
  margin-right: 5px;
  margin-top: 16px;
  font-size: 10px;
  color: gray;
}

</style>



// WEBPACK FOOTER //
// CommentTimelineOverview.vue?219b514c